<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="phone" label="卡面卡号/手机号">
            <el-input v-model.trim="form.phone" placeholder="请输入卡面卡号/手机号" @keyup.enter.native="search" clearable
                      class="search-input" @clear="clear">
              <el-button type="primary" slot="append" @click="search">查询</el-button>
            </el-input>
            <el-button type="primary" @click="save(30)" plain style="margin-left: 10px">挂失</el-button>
            <el-button type="primary" @click="save(10)" plain>恢复</el-button>
            <!--            <el-button type="primary" @click="save()" plain>退卡</el-button>-->
            <el-button type="primary" @click="save(20)" plain>作废</el-button>
          </el-form-item>
        </el-col>
        <el-card class="box-card" v-loading="loading">
          <div class="form-item-title">会员卡信息</div>
          <el-col :span="8">
            <el-form-item prop="cardNum" label="卡面卡号">
              <el-input v-model="formInfo.cardNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="name" label="姓名">
              <el-input v-model="formInfo.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="手机号">
              <el-input v-model="formInfo.phone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="status" label="卡状态" class="form-item-style">
              <el-input v-model="formInfo.statusDesc" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="memberCategoryName" label="卡类型">
              <el-input v-model="formInfo.memberCategoryName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="storeId" label="开卡门店">
              <el-select v-model="formInfo.storeId" placeholder="请选择" disabled>
                <el-option
                  v-for="(item,index) of storeList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="balance" label="储值余额" class="form-item-style">
              <el-input v-model="formInfo.balance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="givingMoney" label="赠送金额" class="form-item-style">
              <el-input v-model="formInfo.givingMoney" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="usableIntegral" label="剩余积分" class="form-item-style">
              <el-input v-model="formInfo.usableIntegral" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="createDttm" label="发卡时间">
              <el-input v-model="formInfo.createDttm" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "../../../config/api";

export default {
  data() {
    return {
      loading: false,
      formInfo: {
        cardNum: '',//卡号
        password: '',
        name: '',
        phone: '',
        status: '',
        statusDesc: '',
        usableIntegral: '',
        balance: '',
        storeId: '',
        createDttm: '',
        memberCategoryName: ''
      },
      form: {
        phone: '',
        id: '',
        status: null,
      },
      rules: {
        phone: [{required: true, message: '请输入卡面卡号或手机号', trigger: 'blur'}],
      },
      title: '',
      storeList: [],
    };
  },
  computed: {
    statusList() {
      return this.$utils.getCacheStatus('mbMember.status')
    },
  },
  created() {
  },
  mounted() {
    this.title = document.title;
    this.getStoreList()
  },
  methods: {
    // 获取门店
    getStoreList() {
      this.$axios.fetchPost(api.store.store + '/list',).then(res => {
        if (res.code == 200) {
          res.data.unshift({id: -1, name: "总部"})
          this.storeList = res.data
        } else {
          this.$message({type: 'error', message: res.msg});
        }
      }).catch(err => {
        this.$message({type: 'error', message: '获取失败!'});
      })
    },
    // 查询
    search() {
      if (!this.form.phone) {
        this.$message({type: 'warning', message: '请输入卡面卡号/手机号'});
        return false;
      }
      this.loading = true
      this.$axios.fetchPost(api.member.mbMemberQuery, {phone: this.form.phone}).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.formInfo = res.data
            this.form.id = res.data.id
            this.formInfo.status = this.statusList.filter(v => v.id === res.data.status)[0].label
          } else {
            this.formInfo = {}
          }
        } else {
          this.$message.error(res.errorMsg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    clear() {
      this.formInfo = {}
    },
    save(val) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let tip = ''
          if (val === 30) {
            tip = '挂失'
          }
          if (val === 10) {
            tip = '恢复'
          }
          if (val === 20) {
            tip = '作废'
          }
          this.$confirm('确认' + tip + '？')
            .then(_ => {
              this.$loading({text: '提交中，请稍后。。。'})
              let params = {
                id: this.form.id,
                status: val
              }
              this.$axios.fetchPost(api.member.mbMemberState, params).then(data => {
                if (data.code === 200) {
                  if (data.data) {
                    if (val === 30 || val === 10) {
                      this.search()
                    } else {
                      this.form = {
                        phone: '',
                        id: '',
                        status: null,
                      }
                      this.clear()
                    }
                  }
                  this.$notify({
                    type: "success",
                    title: '提交操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({type: 'success', message: '操作成功'});
                } else {
                  this.$message({type: 'error', message: data.errorMsg});
                }
              }).catch((err) => {
                this.$message({message: '请求失败', type: 'error'});
              }).finally(() => {
                this.$loading({}).close()
              })
            })
            .catch(_ => {
            });
        } else {
          return false
        }
      })
    },
  }
};
</script>
<style scoped>
.page-template {
  padding: 16px 30px;
}

.page-title {
  text-align: center;
  padding-bottom: 10px;
}

.form-item-title {
  padding-bottom: 10px;
  font-weight: bold;
}

.box-card {
  padding-bottom: 20px;
}

.line {
  border-top: 1px dashed #e0dddd;
  margin-bottom: 20px;
}

.foot {
  padding: 20px;
  text-align: center;
}

/*去掉箭头*/
/deep/ .numrule input::-webkit-outer-spin-button,
/deep/ .numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .numrule input[type="number"] {
  -moz-appearance: textfield;
}

/*单条搜索后面跟的搜索按钮*/
.search-input {
  width: 280px;
  line-height: normal;
}

>>> .el-input-group__append, .el-input-group__prepend {
  background-color: #458cff;
  color: #fff;
  border-color: #458cff;
  font-weight: 700;
}

>>> .el-input.is-disabled .el-input__inner {
  color: #999;
  background-color: #f9f9f9;
}

.form-item-style >>> .el-form-item__label {
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/page/member/ecard/Status.vue